import { NativePurchases, PURCHASE_TYPE } from "@capgo/native-purchases";
import { isAndroidApp } from "@/lib/nativePlatform";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const googlePlayBillingEnabled = process.env.REACT_APP_GOOGLE_PLAY_BILLING_ENABLED === "true";

export const PLAY_PLANS = {
  monthly: { productId: "shaneapp_premium_monthly", basePlanId: "monthly" },
  yearly: { productId: "shaneapp_premium_yearly", basePlanId: "yearly" },
};

const accountToken = async (userId) => {
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(userId));
  return [...new Uint8Array(digest)].map((value) => value.toString(16).padStart(2, "0")).join("");
};

const verify = async (transaction, plan) => {
  if (!transaction.purchaseToken || transaction.purchaseState !== "1") throw new Error("Purchase is not complete");
  const response = await fetch(`${API}/billing/google/verify`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      product_id: plan.productId,
      base_plan_id: plan.basePlanId,
      purchase_token: transaction.purchaseToken,
    }),
  });
  if (!response.ok) throw new Error("Google Play could not verify this purchase");
  return response.json();
};

export const loadPlayProducts = async () => {
  if (!isAndroidApp() || !googlePlayBillingEnabled) return [];
  const { products } = await NativePurchases.getProducts({
    productIdentifiers: Object.values(PLAY_PLANS).map(({ productId }) => productId),
    productType: PURCHASE_TYPE.SUBS,
  });
  return products;
};

export const purchasePlayPlan = async (userId, choice) => {
  const plan = PLAY_PLANS[choice];
  const transaction = await NativePurchases.purchaseProduct({
    productIdentifier: plan.productId,
    planIdentifier: plan.basePlanId,
    productType: PURCHASE_TYPE.SUBS,
    appAccountToken: await accountToken(userId),
    autoAcknowledgePurchases: false,
  });
  return verify(transaction, plan);
};

export const restorePlayPlans = async () => {
  await NativePurchases.restorePurchases();
  const { purchases } = await NativePurchases.getPurchases({ productType: PURCHASE_TYPE.SUBS });
  const knownPlans = Object.values(PLAY_PLANS);
  for (const transaction of purchases) {
    const plan = knownPlans.find(({ productId }) => productId === transaction.productIdentifier);
    if (plan && transaction.purchaseState === "1") await verify(transaction, plan);
  }
};